<template>
  <div class="block_inner">
    <div class="games" :class="{ height_fit: isExpand }">
      <template v-for="(g, idx) in theList" >
        <div class="main_game flex_center border_bottom_1px" :key="idx" >
          <div v-if="type === 2 && idx === 0" class="isPlay bg_contain">
            最近登录
          </div>
          <div class="game_icon mr_6 bg_contain"   :style="{ backgroundImage: `url(${g.gameIcon})` }"></div>
          <div class="game_main flex_1">
            <div class="game_top mb_2 flex_between">
              <div class="game_info">
                <div class="game_title mb_6 fs_15 color_black van-ellipsis">
                  {{ g.gameName }}
                </div>
                <div class="game_desc d_flex">
                  <div class="game_score pr_6 mr_6">{{ g.content }}</div>
                </div>
              </div>
              <div class="game_btn" @click.stop="handleGoGameItem(g)">
                参与活动
              </div>
            </div>
            <GameTag :tags="g.tags" />
          </div>
        </div>
        <!-- 展开的 -->
        <div class="block_extra"  :style="{ height: '76px' }" v-if="g.taskRewardVO"  :key="idx + 'taskRewardVO'">
          <div class="block_wel flex_center">
            <div class="block_wel_icon w_44 h_44 round_5 mr_10 bg_contain" :style="{ backgroundImage: `url(${g.taskRewardVO.icon})` }"></div>
            <div class="block_wel_info flex_1 w_0">
              <div class="block_wel_name bold color_black fs_13 mb_8">
                {{ g.taskRewardVO.name }}
              </div>
              <div class="block_wel_desc fs_10" style="color: #ff7559">
                {{  g.taskRewardVO.type === 2  ? `活跃点数+${g.taskRewardVO.value}` : `${g.taskRewardVO.giftContent}`  }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="block_more flex_center" v-if="showExpand" @click="onExpand">
      <div
        class="block_more_icon bg_contain"
        :class="{ transform_180deg: isExpand }"
        :style="{ backgroundImage: `url(${CDN_URL}/pull.png)` }"
      ></div>
      <div class="block_more_text">{{ !isExpand ? "更多游戏" : "收起" }}</div>
    </div>
    <div v-if="type === 1 && !list.length" class="main_game">
      <p>太厉害了！本期推荐游戏您都在玩！</p>
      <p>快去在玩游戏会场参与活动吧！</p>
    </div>
    <div v-if="type === 2 && !list.length" class="main_game">
      <p>暂无在玩游戏~</p>
      <p>看看推荐游戏会场，</p>
      <p>选择自己喜欢的游戏下载参与活动吧！</p>
    </div>
  </div>
</template>

<script>
import GameTag from "@/views/box/rebate2voucher/gameTag.vue";
import { CDN_URL } from "./config";
export default {
  components: {
    GameTag,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    type: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      isExpand: false,
      CDN_URL,
    };
  },
  computed: {
    /** 最大展示游戏数量 推荐是2个在玩是3个 */
    expandSize() {
      return this.type === 1 ? 2 : 3;
    },
    showExpand() {
      return this.list.length > this.expandSize;
    },
    theList() {
      return this.isExpand ? this.list : this.list.slice(0, this.expandSize);
    },
  },
  methods: {
    handleGoGameItem(g) {
      this.$emit("go", g);
    },
    onExpand() {
      this.isExpand = !this.isExpand;
      this.$emit("expandChange", this.isExpand, this.type);
    },
  },
};
</script>

<style scoped lang="scss">
.isPlay {
  position: absolute;
  top: -8px;
  left: 12px;
  background-image: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_payAmount/tips.png");
  height: 24px;
  line-height: 18px;
  font-size: 10px;
  color: #fefefe;
  width: 58px;
  text-align: center;
  z-index: 1;
}
.block_extra {
  width: calc(100% - 12px);
  margin-left: 6px;
  padding: 8px 16px;
  background-color: #DEECEA;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  margin-bottom: 4px;
  .block_wel {
    background-color: #fff;
    padding: 8px 24px;
    border-radius: 8px;
  }
  .block_wel + .block_wel {
    margin-top: 6px;
  }
}
.main_game {
  background-color: #fff;
  padding: 8px 12px 8px 6px;
  border-radius: 6px;
  position: relative;
  p {
    text-align: center;
    color: #9c9c9c;
    font-size: 13px;
    line-height: 18px;
  }
  .game_icon {
    width: 60px;
    height: 60px;
    border-radius: 6px;
  }
  .game_title {
    white-space: nowrap;
  }
  .game_main {
    .game_score {
      color: #ff2424;
      font-size: 10px;
    }
    .game_info {
      flex: 1;
      width: 0;
    }
  }
  .game_btn {
    padding: 10px 12px;
    font-size: 12px;
    border-radius: 100px;
    color: #fff;
    background-color: #ff5a3f;
  }
}
.main_game + .main_game {
  margin-top: 8px;
}
.games {
  transition: 0.2s height ease;
  max-height: fit-content;
}
.block_inner {
  width: 100%;
  padding: 12px 10px;
  background-color: #6aa39a;
  border-radius: 8px;
  color: #fff;
  .block_more {
    font-size: 13px;
    margin-top: 12px;
  }
  .block_more_icon {
    width: 15px;
    height: 15px;
    margin-right: 12px;
    transition: 0.3s transform ease;
  }
}
.transform_180deg {
  transform: rotate(180deg);
}
.height_fit {
  max-height: unset;
}
</style>
